export const isFeatureAccessible = (currentUserInfo) => {
  if (
    (currentUserInfo?.pricingModel === 1 && !currentUserInfo?.balanceCoins) ||
    (currentUserInfo?.pricingModel === 1 &&
      currentUserInfo?.balanceCoins < 10) ||
    (currentUserInfo?.pricingModel === 0 &&
      !currentUserInfo?.isActiveSubscription)
  )
    return false;

  return true;
};
